function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth
}

export default getScrollbarWidth
